import { render, staticRenderFns } from "./CopyReleaseLink.vue?vue&type=template&id=000c46e0"
import script from "./CopyReleaseLink.vue?vue&type=script&lang=js"
export * from "./CopyReleaseLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports